<template>
  <v-container fluid class="px-6">
    <v-row class="mt-10">
      <AppTitleComponent :title="'Convocatorias'" />
    </v-row>
    <v-toolbar-title class="text-h5 text-wrap mt-10" style="color: #313945;"></v-toolbar-title>
    <!-- Caso: hay invitaciones -> se muestran el filtro, las cards y la paginación -->
    <v-row class="d-flex justify-center" v-if="ListInvitaciones.length !== 0">

      <!-- Card -->
      <!-- Si hay data -->
      <v-col cols="12" sm="6" md="4" lg="3" class="px-3">
        <AppFiltro
          :nombre-ruta="'mis-invitaciones'"
          :instituciones="instituciones"
          :establecimientos="establecimientos"
          :areas-interes="areasInteres"
          @actualizar-filtro="onActualizarFiltro" @limpiar-filtro="onLimpiarFiltro" />
      </v-col>
      <v-col cols="12" sm="6" md="8" lg="9">
        <v-row class="d-flex justify-center">
          <v-col v-for="itemInvitacion in ListInvitaciones" :key="itemInvitacion.id" cols="12">
            <CardConvocatoria @on-click-favorito="gestionarFavorito" @on-click-detalle="verEmpleoDetalle"
              @on-click-rechazar="modalRechazar" @on-click-proceso="procesoPostulacion" :item="itemInvitacion" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12">
        <div class="text-center">
          <AppPaginationPlus v-model="page" :total-pages="totalPages > 0 ? totalPages : 1"
            @change="getListadoInvitaciones" @perPageChange="changePerPage" :selectorPerPage="false" />
        </div>
      </v-col>
    </v-row>

    <!-- Caso: se filtró y no hay resultados -> se muestra solamente el filtro -->
    <v-row class="d-flex justify-start" v-else-if="filtroActivo">
      <v-col cols="12" sm="6" md="4" lg="3" class="px-3">
        <AppFiltro
          :nombre-ruta="'mis-invitaciones'"
          :instituciones="instituciones"
          :establecimientos="establecimientos"
          :areas-interes="areasInteres"
          @actualizar-filtro="onActualizarFiltro" @limpiar-filtro="onLimpiarFiltro" />
      </v-col>
    </v-row>

    <!-- Caso: no hay ninguna invitación y no se ha filtrado -> se muestra la imagen (incluso mientras carga) -->
    <v-row v-else class="fill-height" align="center" justify="center">
      <v-col class="d-flex flex-column justify-center align-center pt-8">
        <v-img :style="`width:${widthImgEmpty};`" src="../../assets/img/emptyConvocatoria.png">
        </v-img>
        <h1 class="text-grey text-center text-h5 font-weight-black text-empty" style="margin-top: -50px; z-index: 1;">
          Aún no tienes convocatorias <br v-if="$vuetify.breakpoint.smAndUp">
          disponibles</h1>
      </v-col>
    </v-row>

    <!-- Modal -->
    <v-dialog v-model="dialog" max-width="490">
      <v-card class="d-flex flex-column justify-center align-center" height="250" style="border-radius: 20px;">
        <v-card-title class="text-h5 text-center primary--text" style="word-break: normal ">
          ¿Estas seguro de rechazar <br> esta oferta de empleo?
        </v-card-title>

        <!-- <v-card-text>

          </v-card-text> -->

        <v-card-actions class="d-flex justify-center align-center">
          <div class="actions-mobile">
            <v-btn
              outlined
              color="primary"
              class="ma-1 text-none"
              rounded
              :class="{
                'mb-8': !$vuetify.breakpoint.smAndDown,
                'mb-5': $vuetify.breakpoint.smAndDown,
              }"
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
            <v-btn
              dark
              color="primary"
              class="ma-1 text-none"
              rounded
              :class="{
                'mb-8': !$vuetify.breakpoint.smAndDown,
                'mb-5': $vuetify.breakpoint.smAndDown,
              }"
              @click="rechazarInvitacion()"
            >
              Guardar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-loader v-if="loading"></app-loader>
  </v-container>
</template>

<script>
import AppLoader from "@/components/AppLoader.vue";
import ChatComponent from "../../components/ChatComponent.vue";
import { mapState } from "vuex";
import CardConvocatoria from "./components/CardConvocatoria.vue";

export default {
  name: "mi-invitacion",
  components: { AppLoader, ChatComponent, CardConvocatoria },
  data: () => ({
    ListInvitaciones: [],
    bgCards: [
      '#f6f6f6',
      '#d2d2db',
      '#e3d3c9',
    ],
    itemRechazar: null,
    invitaciones: [{
      id: 1,
      nombre_institucion: "Secretaria de Innovación",
      plaza: "Diseñador Senior UI/UX",
      color: "#f6f6f6",
      estado: 1,
      nombre_estado: "pendiente"
    }, {
      id: 2,
      nombre_institucion: "Secretaria de Innovación",
      plaza: "Diseñador Senior UI/UX",
      color: "#d2d2db",
      estado: 2,
      nombre_estado: "Aceptada"
    }, {
      id: 3,
      nombre_institucion: "Secretaria de Innovación",
      plaza: "Diseñador Senior UI/UX",
      color: "#e3d3c9",
      estado: 3,
      nombre_estado: "Rechazada"
    }],
    // invitaciones: [],
    dialog: false,
    loading: false,
    message: '',
    windowWidth: window.innerWidth,
    page: 1,
    per_page: 8,
    pagination: false,
    totalRegistros: null,
    search: {
      id_area_interes: null,
      id_institucion: null,
      id_establecimiento: null
    },
    busquedaExitosa: false,
    instituciones: [],
    establecimientos: [],
    areasInteres: [],
  }),

  methods: {
    async changePerPage(per_page) {
      this.loading = true;
      this.per_page = per_page;
      await this.getListadoInvitaciones(null);
      this.loading = false;
    },
    async gestionarFavorito(item) {
      if (this.isTokenValido(this.token)) {
        this.loading = true;
        const body = {
          id_oferta: item,
          id_persona: this.userInfo.id_persona
        };
        try {
          const response = await this.services.favoritos.putFavorito(body);
          if (response.status === 201) {
            this.message = response.data.message
            this.loading = false;
          }
          this.getListadoInvitaciones(null);
        } catch (e) {
          let errorMessage = "Ocurrió un error";
          if (e.response && e.response.data && e.response.data.err) {
            errorMessage = e.response.data.err.message || e.response.data.err.description;
          }
          this.temporalAlert({
            show: true,
            type: "error",
            message: errorMessage
          });
        } finally {
          setTimeout(() => {
          }, 100);
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        });
        this.$router.replace({ name: "login" });
      }
    },
    modalRechazar(item) {
      this.dialog = true
      this.itemRechazar = item
    },

    async verInvitacion(id) {
      //console.log('se acepto', id);
    },

    verEmpleoDetalle(item) {
      let id = item
      this.$router.push(`/empleo/${id}`)
    },

    procesoPostulacion(id, id_oferta) {
      const ofertaId = id_oferta || id;
      if (ofertaId) {
        this.$router.push({ name: 'seguimiento-postulacion', params: { id: ofertaId } });
      }
    },

    async rechazarInvitacion() {
      this.loading = true;
      let id = this.itemRechazar.id
      if (this.isTokenValido(this.token)) {
        // if(this.tieneRoles(this.token)) {
        try {
          const response = await this.services.invitaciones.putInvitacion(id)
          if (response.status == 200) {
            this.temporalAlert({
              show: true,
              message: response.data.message,
              type: "success",
            });
            await this.getListadoInvitaciones(null);
            this.dialog = false
          }
        } catch (e) {

        } finally {
          this.loading = false;
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        })
        this.$router.replace({ name: "login" })
      }

    },

    getBg() {
      return this.bgCards[Math.floor(Math.random() * this.bgCards.length)];
    },

    async getListadoInvitaciones(searchParams) {
      this.loading = true;
      if (this.isTokenValido(this.token)) {
        // if(this.tieneRoles(this.token)) {
        try {
          let params = {
            page: this.page,
            per_page: this.per_page,
            pagination: true,
          }
          if (searchParams) {
            params = { ...params, ...searchParams };
          }
          if (typeof this.userInfo.id_persona !== 'undefined') {
            const response = await this.services.invitaciones.getInvitaciones(this.userInfo.id_persona, params)
            if (response.status == 200) {
              this.ListInvitaciones = response.data?.data;
              this.totalRegistros = response.data?.pagination?.total_rows;
              this.page = response.data?.pagination?.page;
              this.instituciones = response.data?.instituciones;
              this.establecimientos = response.data?.establecimientos;
              this.areasInteres = response.data?.areas_de_interes;
              this.per_page = response.data?.pagination?.per_page;
              this.busquedaExitosa = true;
              //console.log("datos",this.ListInvitaciones)
            }
          }
        } catch (e) {

        } finally {
          this.loading = false;
        }

        // } else {
        //   this.temporalAlert({
        //     show:true,
        //     type:"error",
        //     message:"No tiene permiso para listar sus invitaciones"
        //   })
        // }

      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        })
        this.$router.replace({ name: "login" })
      }
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async onActualizarFiltro(filtro) {
      this.page = 1; // Reinicia la página al actualizar el filtro
      this.search.id_area_interes = filtro.area_interes;
      this.search.id_institucion = filtro.institucion;
      this.search.id_establecimiento = filtro.establecimiento;
      await this.getListadoInvitaciones(this.search);
    },
    async onLimpiarFiltro() {
      this.page = 1; // Reinicia la página al limpiar el filtro
      this.search.id_area_interes = null;
      this.search.id_institucion = null;
      this.search.id_establecimiento = null;
      await this.getListadoInvitaciones(this.search);
    },
  },
  computed: {
    filtroActivo() {
      return Boolean(
        this.search.id_area_interes ||
        this.search.id_institucion ||
        this.search.id_establecimiento
      );
    },
    totalPages() {
      // Validar que los valores existan y sean números válidos
      if (!this.totalRegistros || !this.per_page || this.per_page <= 0) {
        return 1; // Valor por defecto válido
      }

      const totalPaginas = Math.ceil(this.totalRegistros / this.per_page);

      // Asegurar que el resultado sea al menos 1
      return Math.max(totalPaginas, 1);
    },
    screenWidth() {
      return this.windowWidth;
    },
    dinamicCols() {
      if (this.screenWidth <= 1905) {
        return 4;
      }
      return 3
    },
    ...mapState(["userInfo", "token"]),
    widthImgEmpty() {
      if (this.$vuetify.breakpoint.xs) {
        return '90%'
      }
      if (this.$vuetify.breakpoint.sm) {
        return '350px'
      }
      if (this.$vuetify.breakpoint.md) {
        return '400px'
      }
      if (this.$vuetify.breakpoint.lg) {
        return '420px'
      }
      if (this.$vuetify.breakpoint.xl) {
        return '500px'
      }
    },
  },
  created() {

    this.loading = true;
    setTimeout(async () => {
      await this.getListadoInvitaciones(null);
      this.loading = false;
    }, 2000);

  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 500px) {
  .text-empty {
    font-size: 1em !important;
  }
}

.text-grey {
  color: #616161;
}

@media (max-width: 672px) {
  .actions-mobile {
    width: 95%;
  }

  .actions-mobile .v-btn {
    display: block;
    width: 95%;
  }
}
</style>
